import _ from 'lodash';
import axios from 'axios';
import Utility from 'Utility';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default {
    namespaced: true,
    state: {
        project: null,
        submittal: null,
        products: null,
        temporaryProducts: [],
        toBeDeleted: [],
        listOfSubmittals: null
    },
    getters: {
        submittal(state) {
            return state.submittal;
        },
        project(state) {
            return state.project;
        },
        products(state) {
            return state.products;
        },

        /* state.temporaryProducts exists so I can do work on products while
        * maintaining the original state
        * */

        temporaryProducts(state) {
            return state.temporaryProducts;
        },
        listOfSubmittals(state) {
            return state.listOfSubmittals;
        }
    },
    actions: {
        getListOfSubmittals({commit}, id) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'get',
                    url: '/actions/anvil-module/project/list',
                    params: {
                        id: id
                    }
                })
                .then(response => {
                    if (response.data.length) {
                        commit('setProject', response.data[0].project);
                        commit('setListOfSubmittals', response.data[0].submittals);
                    }
                    resolve(response.data);
                })
                .catch(response => {
                    console.log(response)
                    reject(response);
                })
            });
        },

        getSubmittalInfo({commit}, id) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'get',
                    url: '/actions/anvil-module/mechanical-submittal/get-info',
                    params: {
                        id: id
                    }
                })
                .then(response => {
                    commit('setProject', response.data.project);
                    commit('setSubmittal', response.data.submittal);
                    commit('setProducts', response.data.products);

                    resolve();
                })
                .catch(error => {
                    reject();
                });
            });
        },

        editSubmittalInfo({dispatch}, payload) {
            return new Promise((resolve, reject) => {

                let form = new FormData();
                form.append('id', payload.id);
                form.append('name', payload.name);
                form.append('notes1', payload.notes1);
                form.append('notes2', payload.notes2);

                axios({
                    method: 'post',
                    url: '/actions/anvil-module/mechanical-submittal/edit',
                    data: form
                })
                .then(response => {
                    dispatch('getSubmittalInfo', response.data.id);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });

            });
        },

        createSubmittalInfo({}, payload) {
            return new Promise((resolve, reject) => {

                let form = new FormData();
                form.append('projectId', payload.id);
                form.append('name', payload.name);
                form.append('notes1', payload.notes1);
                form.append('notes2', payload.notes2);

                axios({
                    method: 'post',
                    url: '/actions/anvil-module/mechanical-submittal/create',
                    data: form
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });

            });
        },

        deleteItem({}, payload) {
            return new Promise((resolve, reject) => {

                let form = new FormData();
                form.append('id', payload.id);

                axios({
                    method: 'post',
                    url: payload.url,
                    data: form
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });

            });
        },

        copyItem({}, payload) {
            return new Promise((resolve, reject) => {

                let form = new FormData();
                form.append('id', payload.id);

                axios({
                    method: 'post',
                    url: payload.url,
                    data: form
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });

            });
        },

        saveProducts({state}, submittalID) {
            console.log('saveProducts')

            return new Promise((resolve, reject) => {
                console.log('saveProducts Promise')

                let form = new FormData();
                form.append('submittalId', submittalID);

                _.each(state.temporaryProducts, product => {
                    form.append('productId[]', product.objectID);
                });

                axios({
                    method: 'post',
                    url: '/actions/anvil-module/mechanical-submittal/add-products',
                    data: form
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });

            });
        },
        saveProduct({state}, payload) {
            return new Promise((resolve, reject) => {

                let form = new FormData();
                form.append('submittalId', payload.submittalID);
                form.append('productId[]', payload.productID);

                axios({
                    method: 'post',
                    url: '/actions/anvil-module/mechanical-submittal/add-products',
                    data: form
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });

            });
        },

        deleteProducts({state}, submittalID) {
            console.log('deleteProducts')

            return new Promise((resolve, reject) => {
                console.log('deleteProducts Promise')

                if (state.toBeDeleted.length < 1) {
                    resolve();
                    return;
                }

                let form = new FormData();

                form.append('submittalId', submittalID);

                _.each(state.toBeDeleted, product => {
                    form.append('productId[]', product.objectID);
                });

                axios({
                    method: 'post',
                    url: '/actions/anvil-module/mechanical-submittal/delete-product',
                    data: form
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });

            });
        },

        deleteProduct({}, payload) {
            return new Promise((resolve, reject) => {

                let form = new FormData();
                form.append('submittalId', payload.submittalID);
                form.append('productId[]', payload.objectID);

                axios({
                    method: 'post',
                    url: '/actions/anvil-module/mechanical-submittal/delete-product',
                    data: form
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
            });
        },

        saveOrder({state}, submittalID) {
            return new Promise((resolve, reject) => {

                let form = new FormData();
                form.append('submittalId', submittalID);

                _.each(state.products, (product, index) => {
                    form.append('productId[]', product.productId);
                    form.append('sortOrder[]', index++);
                });

                axios({
                    method: 'post',
                    url: '/actions/anvil-module/mechanical-submittal/reorder-products',
                    data: form
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
            });
        },

        getProductRelations({}, id) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'get',
                    url: '/actions/anvil-module/mechanical-submittal/get-product-usage',
                    params: {
                        productId: id
                    }
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
            });
        },

        getProductInfo({}, id){
            return new Promise((resolve, reject) => {
                axios({
                    method: 'get',
                    url: '/actions/anvil-module/product-info',
                    params: {
                        id: id
                    }
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
            });
        }
    },
    mutations: {
        setProject(state, project) {
            state.project = project;
        },

        setSubmittal(state, submittal) {
            state.submittal = submittal;
        },

        setProducts(state, products) {

            state.temporaryProducts = [];

            _.each(products, product => {
                state.temporaryProducts.push(
                    {
                        objectID: product.productId,
                        title: product.name,
                        submittalFile: product.submittalFile
                    }
                )
            });

            state.products = products;
        },

        setListOfSubmittals(state, listOfSubmittals) {
            state.listOfSubmittals = listOfSubmittals;
        },

        addProduct(state, product) {
            state.temporaryProducts.push(product);
        },

        removeProduct(state, id) {
            state.temporaryProducts = _.remove(state.temporaryProducts, product => {
                if (product.objectID != id) {
                    return true
                } else {
                    state.toBeDeleted.push(product);
                }
            });
        },

        reorderProducts(state, payload) {
            state.products = payload;
        }

    },
};
